import { ReactNode } from 'react'
import CalculationPosition from '../../../types/api/calculation-position'
import { DataSourceItem } from './convert-calculations-to-data-source'
import isCalculation from './is-calculation'
import { FieldDescriptors } from '../../../components/editable-cell/editable-cell'

export const renderCalcPos = (
    render: (r: CalculationPosition, v: any, i: number) => ReactNode | undefined
) => {
    return (v: any, r: DataSourceItem, i: number) => {
        if (isCalculation(r)) return null
        return render(r, v, i)
    }
}

export const onAnyStandardCell = (record: DataSourceItem) => {
    if (isCalculation(record)) {
        return { colSpan: 0 }
    }
    return { colSpan: 1 }
}

export const VIRTUAL_STAMP_FIELD_DESCRIPTORS: FieldDescriptors[] = [
    {
        name: ['virtualStamp', 'width'],
        getValue: (r: CalculationPosition) => r.virtualStamp?.width,
    },
    {
        name: ['virtualStamp', 'length'],
        getValue: (r: CalculationPosition) => r.virtualStamp?.length,
    },
    {
        name: ['virtualStamp', 'floods'],
        getValue: (r: CalculationPosition) => r.virtualStamp?.floods,
    },
    {
        name: ['virtualStamp', 'roller', 'set'],
        getValue: (r: CalculationPosition) => r.virtualStamp?.roller?.documentId,
    },
    {
        name: ['virtualStamp', 'range'],
        getValue: (r: CalculationPosition) => r.virtualStamp?.range,
    },
    {
        name: ['virtualStamp', 'rollerVariant'],
        getValue: (r: CalculationPosition) =>
            JSON.stringify({
                roller: r.virtualStamp?.roller?.documentId,
                distance: r.virtualStamp?.range,
            }),
    },
]
